// constants/lookupFieldOptions.ts

export const LOOKUP_FIELD_OPTIONS: Record<
  number,
  { id: number; title: string }[]
> = {
  1: [
    { id: 1, title: "registrations" },
    { id: 2, title: "qftd" },
    { id: 3, title: "cpa_income" },
    { id: 4, title: "revshare_income" },
    { id: 5, title: "total_income" },
    { id: 6, title: "net_revenue" },
    { id: 7, title: "number_of_deposits" },
    { id: 8, title: "deposit_amount" },
    { id: 9, title: "number_of_cash_bets" },
    { id: 10, title: "sum_of_cash_bets" },
    { id: 11, title: "backend_brand_name" },
    { id: 12, title: "deal_plan_name" },
    { id: 13, title: "activity_date" },
  ],
  2: [
    { id: 1, title: "registrations" },
    { id: 2, title: "ftd" },
    { id: 3, title: "qftd" },
    { id: 4, title: "cpa_income" },
    { id: 5, title: "revshare_income" },
    { id: 6, title: "total_income" },
    { id: 7, title: "net_revenue" },
    { id: 8, title: "number_of_deposits" },
    { id: 9, title: "deposit_amount" },
    { id: 10, title: "number_of_cash_bets" },
    { id: 11, title: "sum_of_cash_bets" },
    { id: 12, title: "backend_brand_nameme" },
    { id: 13, title: "deal_plan_name" },
    { id: 14, title: "activity_date" },
  ],
  4: [
    { id: 1, title: "user_unique_id" },
    { id: 2, title: "registrations" },
    { id: 3, title: "ftd" },
    { id: 4, title: "qftd" },
    { id: 5, title: "cpa_income" },
    { id: 6, title: "revshare_income" },
    { id: 7, title: "total_income" },
    { id: 8, title: "net_revenue" },
    { id: 9, title: "number_of_deposits" },
    { id: 10, title: "deposit_amount" },
    { id: 11, title: "number_of_cash_bets" },
    { id: 12, title: "sum_of_cash_bets" },
    { id: 13, title: "turnover" },
    { id: 14, title: "wins_sum" },
    { id: 15, title: "commission_type" },
    { id: 16, title: "backend_player_account" },
    { id: 17, title: "backend_campaign_id" },
    { id: 18, title: "backend_campaign_name" },
    { id: 19, title: "backend_brand_name" },
    { id: 20, title: "deal_plan_name" },
    { id: 21, title: "activity_date" },
  ],
};
